import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "baloon-chat_8ed76ebb6b0f432392fb4416215a43f8",
  "use": "baloon-chat_8ed76ebb6b0f432392fb4416215a43f8-usage",
  "viewBox": "0 0 86 75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 86 75\" id=\"baloon-chat_8ed76ebb6b0f432392fb4416215a43f8\">\n    <path d=\"M43 0C19.25 0 0 15.586 0 34.821c0 8.304 3.595 15.904 9.574 21.881C7.474 65.14.454 72.656.37 72.74c-.37.385-.47.954-.252 1.456.218.503.688.804 1.226.804 11.136 0 19.484-5.324 23.616-8.605A51.379 51.379 0 0 0 43 69.643c23.75 0 43-15.586 43-34.822C86 15.586 66.75 0 43 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id